'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withDevice = require('../with-device');

var _withDevice2 = _interopRequireDefault(_withDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Drawer = function (_React$Component) {
  _inherits(Drawer, _React$Component);

  function Drawer(props) {
    _classCallCheck(this, Drawer);

    var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

    _this.state = {
      height: null
    };
    return _this;
  }

  _createClass(Drawer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.device.height !== this.props.device.height) {
        this.setState({
          height: nextProps.device.height - this.aside.getBoundingClientRect().top
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          open = _props.open,
          onClose = _props.onClose;

      var drawerOverlayClasses = (0, _classnames2.default)('drawer-overlay', open && 'drawer-overlay--is-open');
      var drawerClasses = (0, _classnames2.default)('drawer', open && 'drawer--is-open');
      var commonStyles = {
        height: this.state.height + 'px'
      };

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement('div', {
          key: 'drawwer-overlay',
          className: drawerOverlayClasses,
          onClick: onClose,
          style: commonStyles
        }),
        _react2.default.createElement(
          'aside',
          {
            key: 'drawwer',
            ref: function ref(aside) {
              _this2.aside = aside;
            },
            className: drawerClasses,
            style: commonStyles
          },
          children
        )
      );
    }
  }]);

  return Drawer;
}(_react2.default.Component);

Drawer.propTypes = {
  children: _propTypes2.default.node,
  open: _propTypes2.default.bool,
  device: _propTypes2.default.object,
  onClose: _propTypes2.default.func
};

Drawer.defaultProps = {
  onClose: function onClose() {
    return null;
  }
};

exports.default = (0, _withDevice2.default)(Drawer);